import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Button, Container, Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import { Creators as UserActions } from "../../../store/ducks/users";
import Layout from "../../Layout/Layout";
import usersPageStyle from "./usersPageStyle";
import CustomModal from "../../CustomModal/CustomModal";
import UserItem from "../../UserItem/UserItem";
import UserRegister from "../../UserRegister/UserRegister";
import { notifyError, notifySuccess } from "../../../utils/js/helpers";
import Loader from "../../Loader/Loader";

const useStyles = makeStyles((theme) => usersPageStyle(theme));

const UsersPage = ({ getAllAvailableUsers, resetPassword, users, removeUserById }) => {
  const classes = useStyles();
  const [listUsers, setListUsers] = React.useState([]);
  const [showModal, setShowModal] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  const { data, type } = users;

  useEffect(() => {
    if (!listUsers.length) {
      getAllAvailableUsers();
    }
  }, [getAllAvailableUsers, listUsers])

  useEffect(() => {
    if (type === "users/GET_ALL") {
      setListUsers(data);
      setLoading(false);
    }
    if (type === "users/REMOVE") {
      notifySuccess('Usuário removido!');
      getAllAvailableUsers();
    }
    if (type === "users/ERROR") {
      notifyError('Não foi possível adicionar o usuário!');
      getAllAvailableUsers();
    }
  }, [data, type, getAllAvailableUsers]);

  const handleClosingModal = () => {
    setShowModal(false);
    getAllAvailableUsers();
  }

  return (
    <div className={classes.root}>
      <Layout title="Usuários">
        <CustomModal open={showModal} onClose={handleClosingModal}>{(
          <UserRegister onFinished={handleClosingModal}/>
        )}</CustomModal>

        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Paper className={classes.containerProducts}>
              <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
              >
                <Typography
                  component="h1"
                  variant="h5"
                  color="inherit"
                  noWrap
                  className={classes.title}
                >
                  Lista de usuários ativos
                </Typography>

                <Button variant="contained" className={classes.registerButton} onClick={() => setShowModal(true)}>
                  cadastrar
                </Button>
              </Grid>

              { loading ? (
                <div className={classes.loadingWrap}>
                  <Loader />
                </div>
              ) : <div/>}
              
              {listUsers?.map((user) => (
                <UserItem key={user.Id} resetPassword={resetPassword} removeUserById={removeUserById} user={user} />
              ))}
            </Paper>
          </Container>
        </main>
      </Layout>
    </div>
  );
};

const mapStateToProps = ({ users }) => ({ users });
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(UserActions, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage);
